import { DocumentCompareAction, DocumentCompareActionType, DocumentCompareState } from './types';

export const initialData: DocumentCompareState = {
    isInCompareMode: false,
    firstFile: null,
    secondFile: null,
    structureId: null,
};

export const reducer = (
    state: DocumentCompareState,
    action: DocumentCompareActionType,
): DocumentCompareState => {
    switch (action.type) {
        case DocumentCompareAction.EnterCompareMode:
            return {
                ...state,
                isInCompareMode: true,
                structureId: action.payload,
            };

        case DocumentCompareAction.ExitCompareMode:
            return {
                ...state,
                isInCompareMode: false,
                firstFile: null,
                secondFile: null,
                structureId: null,
            };

        case DocumentCompareAction.SetFirstFile:
            return {
                ...state,
                firstFile: action.payload,
            };

        case DocumentCompareAction.SetSecondFile:
            return {
                ...state,
                secondFile: action.payload,
            };

        case DocumentCompareAction.ClearFiles:
            return {
                ...state,
                firstFile: null,
                secondFile: null,
            };

        default:
            return state;
    }
};
